<ng-container *transloco="let t" class="container">
  <div class="form-floating {{cssClass ? cssClass : ''}}">
    <div class="form-check form-switch">
      <input type="checkbox" id="{{formControlName}}" class="form-check-input" [placeholder]="placeholder ?
      t(placeholder) :
           t(label!)" [formControl]="control">
      @if (label) {
      <label class="form-check-label" for="{{formControlName}}">{{
        t(label!)
        }}@if (control.errors?.['required']) {
        <span>*</span>
        }</label>
      }
      @if (control.touched) {
      @for(errorMessage of control.errors | errorMessages:formControlName; track errorMessage){
      <div class="errorMes pt-1">
        {{ errorMessage }}
      </div>
      }
      }
    </div>
  </div>
</ng-container>